import ConfigService from '../index'
class AtendimentoService extends ConfigService {
    constructor(){
        super('atendimento/api/v1/atendimento/')
    }

    
}
export default AtendimentoService
